function blogPath(siteTag, path = '', langKey = undefined) {
  let blogLink = '';
  const pathPrefix = langKey ? `/${langKey}` : '';
  let adjustedPrefix = pathPrefix;

  switch (siteTag) {
    case 'site:foodstars':
      blogLink = '/insights';
      break;

    case 'site:cooklane':
      if (path.toString().includes('/fr/blog/'))
        path = path.replace('/fr/blog/', '/');

      blogLink = `${pathPrefix}/blog`;
      break;

    case 'site:citychefs':
      if (path.toString().includes('/it/')) path = path.replace('/it/', '/');

      blogLink = `${pathPrefix}/blog`;
      break;

    case 'site:kitchenpark':
      if (path.toString().includes('/ar/')) path = path.replace('/ar/', '/');

      adjustedPrefix = langKey === 'ar' ? '/ar-sa' : pathPrefix;
      blogLink = `${adjustedPrefix}/blog`;
      break;

    default:
      blogLink = `${pathPrefix}/blog`;
      break;
  }

  if (path === '') return `${blogLink}/`;

  if (path[0] === '/') return `${blogLink}${path}`;

  return `${blogLink}/${path}`;
}

function blogArticlePath(siteTag, path = '', langKey = undefined) {
  const pathPrefix = langKey ? `/${langKey}` : '';
  let adjustedPrefix = pathPrefix;

  switch (siteTag) {
    case 'site:foodstars':
      return `${path}`;

    case 'site:cooklane':
      if (path.toString().includes('/fr/blog/'))
        path = path.replace('/fr/blog/', '/');

      return `${pathPrefix}/blog${path}`;

    case 'site:citychefs':
      if (path.toString().includes('/it/')) path = path.replace('/it/', '/');

      return `${pathPrefix}/blog${path}`;

    case 'site:kitchenpark':
      if (path.toString().includes('/ar/')) path = path.replace('/ar/', '/');

      adjustedPrefix = langKey === 'ar' ? '/ar-sa' : pathPrefix;
      return `${adjustedPrefix}/blog${path}`;

    default:
      return `${pathPrefix}/blog${path}`;
  }
}

// Function to get current url
const getCurrURL = () => {
  const urlString = window.location.href;
  const url = new URL(urlString);

  return url.href;
};

module.exports = { blogPath, blogArticlePath, getCurrURL };
